import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer2RownanieTerenu() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/rownanie-terenu-Duzy.jpeg"
          alt="Równanie terenu - wyrównanie powierzchni działki - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Równanie i wyrównywanie terenu działek budowlanych Gdańsk, Gdynia
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Maszynowe profilowanie gruntu minikoparką i ładowarką
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Nierówna działka z wybojami, górkami lub spadkami utrudnia budowę oraz prawidłowe zagospodarowanie posesji w Wejherowie, Kartuzach, Gdańsku i na Kaszubach. Wykonujemy maszynowe równanie terenu, usuwanie hałd ziemi oraz przygotowanie podłoża pod nawierzchnie i zieleń. Idealnie wyrównany grunt to podstawa pod <a href="/zakladanie-ogrodu/trawa-z-siewu" className="underline hover:opacity-80">zakładanie trawników z siewu</a> lub rolki.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie sprawdzi się niwelowanie terenu?
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Na czym polega niwelacja terenu?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czy do założenia trawnika potrzebna jest niwelacja?
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Ile kosztuje niwelacja terenu?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Gdzie sprawdzi się niwelowanie terenu?</h2>
          <p>
            Naturalnie ukształtowany grunt rzadko bywa całkowicie płaski. Przeprowadzenie mechanicznego równania terenu przed budową pozwala zredukować koszty wznoszenia fundamentów i ułatwia poruszanie się maszyn. Profilowanie poziomu gruntu sprawdza się także na obszarach rolnych, poprawiając retencję wody i warunki uprawowe.
          </p>
          <p>
            Wyrównanie terenu wykonuje się często po oczyszczeniu działki z samosiejek czy mulczowaniu zarośli. Dobrze splanowany i płaski teren podnosi walory wizualne nieruchomości, co ma duże znaczenie przy sprzedaży działek inwestycyjnych lub komercyjnych.
          </p>
          <p>
            Właściwe wypoziomowanie gruntu jest kluczowe pod budowę tarasów, podjazdów czy ścieżek brukowanych. Umożliwia to zachowanie odpowiednich spadków odprowadzających wodę deszczową od budynku.
          </p>
          <p>
            Również stabilne i proste podłoże pod basen ogrodowy wymaga wcześniejszego usunięcia nierówności. Zapobiega to przechylaniu się konstrukcji i nierównomiernemu naporowi wody na ściany basenu.
          </p>

          <p>Oferowane przez nas usługi profilowania terenu:</p>
          <ul>
            <li>niwelacja terenu pod trawnik</li>
            <li>niwelacja terenu pod ogród</li>
            <li>wyrównanie terenu pod budowę</li>
            <li>równanie działki po budowie</li>
            <li>przygotowanie terenu pod oczko wodne</li>
            <li>równanie terenu pod taras</li>
            <li>przygotowanie terenu pod basen</li>
          </ul>

          <h2 id="2">Na czym polega niwelacja terenu?</h2>
          <p>
            Równanie działki polega na przemieszczeniu mas ziemnych w celu zniwelowania uskoków i zagłębień. Maszyny usuwają pagórki i zasypują doliny, tworząc jednolitą płaszczyznę ułatwiającą realizację kolejnych etapów budowlanych lub brukarskich.
          </p>
          <p>
            W zależności od projektu ogrodu, możemy uformować teren w kaskady, ozdobne skarpy lub nasypy. Nasi operatorzy potrafią precyzyjnie wymodelować profil ziemi pod przyszłe nasadzenia roślinne lub architekturę ogrodową.
          </p>

          <h2 id="3">Czy do założenia trawnika potrzebna jest niwelacja?</h2>
          <p>
            Prawidłowo ukształtowany grunt pod trawnik eliminuje zaleganie wody w zagłębieniach i zapobiega uszkodzeniom kosiarki podczas pielęgnacji murawy.
          </p>
          <p>
            Dotyczy to zarówno trawników z siewu, jak i z rolki, które wymagają idealnego przylegania do podłoża. Ręczne wyrównywanie dużych powierzchni bywa niezwykle męczące, dlatego warto zastosować profesjonalny sprzęt mechaniczny.
          </p>
          <p>
            Maszynowe profilowanie terenu gwarantuje precyzję, której nie sposób osiągnąć tradycyjnymi narzędziami ręcznymi. Zapewniamy kompleksowość usług – po wyrównaniu terenu możemy od razu przystąpić do siewu lub ułożenia trawy.
          </p>

          <h2 id="4">Ile kosztuje niwelacja terenu?</h2>
          <p>
            Koszt prac ziemnych zależy od ukształtowania posesji, kubatury przemieszczanej ziemi oraz odległości dojazdu sprzętu. Aby poznać wstępną wycenę równania terenu, zachęcamy do wypełnienia formularza kontaktowego lub przesłania zdjęć poglądowych działki. W razie potrzeby bezpłatnie dojedziemy na miejsce w celu dokładnej oceny.
          </p>
          <p>
            Skontaktuj się z nami już teraz, aby ustalić dogodny termin i otrzymać darmową wycenę. Powierz te trudne prace profesjonalistom i ciesz się doskonale przygotowanym gruntem.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-0.jpeg"
              alt="Równanie terenu - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-1.jpeg"
              alt="Równanie terenu - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-3.jpeg"
              alt="Równanie terenu - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/niwelacja-rownanie-1.jpeg"
              alt="Równanie terenu - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/niwelacja-rownanie-2.jpg"
              alt="Równanie terenu - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/niwelacja-rownanie-3.jpg"
              alt="Równanie terenu - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/niwelacja-terenu-2-1.jpeg"
              alt="Równanie terenu - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/niwelacja-terenu-1-1.jpeg"
              alt="Równanie terenu - realizacja Drzewus nr 8"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer2RownanieTerenu;
